export enum ContentCheckInsTabViews {
  CurrentContent = 1,
  OnReview = 2,
}
